

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { OntarioEhtSetup } from "../../components/OntarioEhtSetup";


export const OntarioEhtSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="EHT Ontario"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Company", navigateTo: "/company/OntarioEht/list" },
        { text: "EHT Ontario", navigateTo: "/company/OntarioEht/setup" }
      ]}
      mainContents={<OntarioEhtSetup />}
    />
  );
};
